import React from "react";
import { formatAppDate } from "../../../helpers/date-formatter";
import DataTable from "../../table/DataTable";
import StatusBadge from "../../table/StatusBadge";

function CampaignPrizeUserTable({ prizeUsers, offset }) {
  const columns = [
    {
      key: "sn",
      label: "SN",
      width: "90px",
      render: (_, key) => (offset && !offset.isNaN ? offset + key + 1 : key + 1),
    },
    { key: "username", label: "Username" },
    { key: "userId", label: "User ID", width: "140px" },
    { key: "couponCode", label: "Coupon Code", width: "170px" },
    {
      key: "couponStatus",
      label: "Coupon Status",
      width: "170px",
      render: (item) => <StatusBadge active={item.couponActive} />,
    },
    {
      key: "usedOn",
      label: "Used On",
      width: "150px",
      render: (item) => (item.usedOn !== null ? formatAppDate(item.usedOn) : "-"),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={prizeUsers}
      rowKey={(item) => `${item.userId}-${item.couponCode}`}
      minWidth="800px"
      emptyMessage="No prize users found."
    />
  );
}

export default CampaignPrizeUserTable;
